module.exports = __webpack_public_path__ + "static/media/person.8c957c00.svg";